import { useTranslation } from "react-i18next";
import { useInterviewContext } from "./InterviewContext";
import HeaderThreeDotsDropDown from "./HeaderThreeDotsDropDown";
import IconStarActive from "./../../layout/others/icon_star_idle_yellow.svg";
import IconStarInactive from "./../../layout/others/icon_star_idle.svg";
import { InterviewService } from "../../services/InterviewService";
import Select from "../../components/Select";
import { useEffect } from "react";
import { useState } from "react";
import { JobRoleDetailService } from "../../services/JobRoleDetailService";
import JobRoleDetails from "../../components/JobRoleDetailsTree/JobRoleDetails";
import TechAreaInterviewHelper from "../../pages/Interview/TechAreaInterviewHelper";
import TechAreaInterestInterviewHelper from "../../pages/Interview/TechAreaIntrestInterviewHelper";
import { TechRoleService } from "../../services/TechRoleService";
import { DropDownMultiCheck } from "./AdvanceSearch/DropDownMultiCheck";

const InterviewPageHeader = () => {
  const { t } = useTranslation();
  const {
    interview,
    errors,
    managerInterest,
    setInterview,
    editMode,
    availabilityListStatus,
    sendDocOnline,
    openModalInterviewHistory,
    openFinancialCalculation
  } = useInterviewContext();
  const [candidateInterest, setCandidateInterest] = useState(
    interview.personalInformation?.candidateInterestBusinessAreaId ||
      interview.personalInformation?.candidateInterestTechAreaId ||
      interview.personalInformation?.candidateInterestTechRoleId
  );

  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [candidateInterestTechRoles, setCandidateInterestTechRoles] = useState(
    []
  );
  const [candidateInterestTechAreas, setCandidateInterestTechAreas] = useState(
    []
  );
  const [
    candidateInterestBusinessAreas,
    setCandidateInterestBusinessAreas
  ] = useState([]);
  const SCREENCALL = 2;
  function onChangeCandidateInterest({ target }) {
    setCandidateInterest(target.checked);
  }

  function getBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreas(data);
    });
  }

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreas(data);
    });
  }

  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoles(data);
    });
  }

  function getTechInterestRoles(candidateInterestTechAreaId) {
    JobRoleDetailService.getAllTechRoles(candidateInterestTechAreaId).then(
      (data) => {
        setCandidateInterestTechRoles(data);
      }
    );
  }

  useEffect(() => {
    getBusinessAreas();
    getTechAreas();
    getCandidateInterestBusinessAreas();
    getCandidateInterestTechAreas();
  }, []);

  useEffect(() => {
    if (interview.personalInformation?.candidateInterestTechAreaId)
      getCandidateInterestTechRoles(
        interview.personalInformation.candidateInterestTechAreaId
      );
  }, [interview.personalInformation?.candidateInterestTechAreaId]);

  function getCandidateInterestBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setCandidateInterestBusinessAreas(data);
    });
  }

  function getCandidateInterestTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setCandidateInterestTechAreas(data);
    });
  }

  function getCandidateInterestTechRoles(candidateInterestTechAreaId) {
    JobRoleDetailService.getAllTechRoles(candidateInterestTechAreaId).then(
      (data) => {
        setCandidateInterestTechRoles(data);
      }
    );
  }

  useEffect(() => {
    if (interview.personalInformation?.techAreaId) {
      getTechRoles(interview.personalInformation?.techAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoles(data));
    }
  }, [interview.personalInformation?.techAreaId]);

  useEffect(() => {
    if (interview.personalInformation?.candidateInterestTechAreaId) {
      getTechInterestRoles(
        interview.personalInformation?.candidateInterestTechAreaId
      );
    } else {
      TechRoleService.getAllTechRoles().then((data) =>
        setCandidateInterestTechRoles(data)
      );
    }
  }, [interview.personalInformation?.candidateInterestTechAreaId]);

  function toggleFavorite() {
    if (interview.favorite) {
      InterviewService.deleteFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: false });
      });
    } else {
      InterviewService.addFavorite(interview.interviewId).then(() => {
        setInterview({ ...interview, favorite: true });
      });
    }
  }

  const onChange = (event) =>
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        [`${event.target.name}`]: event.target.value || null
      }
    }));

  const onchangeBusinessAreas = (businessAreas) => {
    setInterview({ ...interview, businessAreas: businessAreas });
  };
  const onchangeCandidateBusinessAreas = (businessAreas) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      candidateBusinessAreas: businessAreas
    }));
  };
  return (
    <div className="card inboard p-4">
      <div className="filters">
        <div className="row">
          <div className="col-md-3 business-area-width">
            {" "}
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Business Area")}</label>
                {errors.businessAreaId && (
                  <div className="error-msg">{errors.businessAreaId}</div>
                )}
              </div>

              <DropDownMultiCheck
                dataList={businessAreas}
                selecteds={interview.businessAreas || []}
                setSelecteds={onchangeBusinessAreas}
                label={t("Business Area...")}
                hideSelected={true}
              />
            </div>
          </div>
          <div className="col-md-5 mt-1">
            <div className="form-group">
              <JobRoleDetails
                searchObject={interview.personalInformation}
                onChange={onChange}
                techAreas={techAreas}
                techRoles={techRoles}
              >
                <TechAreaInterviewHelper
                  searchObject={interview.personalInformation}
                  onChange={onChange}
                  techAreaList={techAreas}
                  techRoleList={techRoles}
                  errors={errors}
                />
              </JobRoleDetails>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Manager Interest")}</label>
              </div>
              <Select
                id="managerInterest"
                name="interestTypeId"
                //className="form-select"
                className={
                  interview.personalInformation.interestType === "Not Hiring"
                    ? "notHireBorder form-select"
                    : "form-select"
                }
                onChange={onChange}
                value={
                  (interview.personalInformation &&
                    interview.personalInformation?.interestTypeId) ||
                  0
                }
                required
                title={t("Select item from list")}
              >
                <option key={0} value={0} selected>
                  {t("Select interest...")}
                </option>
                {managerInterest?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="col text-end-interview-header d-flex">
            {interview.lastFeedback && (
              <div
                className="form-group"
                style={{ marginRight: "17px", width: "110px" }}
              >
                <div className="label-wrapper">
                  <label>{t("Last Feedback")}</label>
                </div>
                <input
                  id="lastFeedbackDate"
                  name="lastFeedbackDate"
                  type="text"
                  value={interview.lastFeedback}
                  disabled
                />
              </div>
            )}
            <div
              className="align-bottom me-3"
              style={{ height: "35px", marginTop: "14px" }}
            >
              <span title={t("Availability")}>
                {!availabilityListStatus ? (
                  <i
                    class="bi bi-unlock"
                    style={{
                      fontSize: "2em"
                    }}
                  ></i>
                ) : (
                  <i
                    class="bi bi-lock"
                    style={{
                      fontSize: "2em"
                    }}
                  ></i>
                )}
              </span>
            </div>

            {editMode && (
              <>
                <div
                  className="align-bottom me-3"
                  style={{ height: "35px", marginTop: "17px" }}
                >
                  <img
                    src={interview.favorite ? IconStarActive : IconStarInactive}
                    alt="ico-ppl"
                    title={t("Add to favorites")}
                    width="auto"
                    height="100%"
                    onClick={toggleFavorite}
                  />
                </div>

                <HeaderThreeDotsDropDown
                  isInterviewActive={interview.isActive}
                  hasInterviewId={interview.interviewId === 0}
                  fromUrl="CreateOrEdit"
                  hideOnscreenCall={interview.typeOfInterview === SCREENCALL}
                  openInterviewPage={openFinancialCalculation}
                  openModalInterviewHistory={openModalInterviewHistory}
                  sendDocOnline={sendDocOnline}
                  interview={interview}
                  setInterview={setInterview}
                  toggleFavorite={toggleFavorite}
                  editMode={editMode}
                />
              </>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckDefault"
              >
                {t("Another area of interest?")}
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  onChange={onChangeCandidateInterest}
                  checked={candidateInterest}
                  disabled={
                    interview.personalInformation
                      ?.candidateInterestBusinessAreaId ||
                    interview.personalInformation
                      ?.candidateInterestTechAreaId ||
                    interview.personalInformation?.candidateInterestTechRoleId
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {(candidateInterest ||
          interview.candidateBusinessAreas?.length > 0) && (
          <div className="row">
            <div className="col-md-3 business-area-width">
              {" "}
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Business Area Interest")}</label>
                  {errors.candidateInterestBusinessAreaId && (
                    <div className="error-msg">
                      {errors.candidateInterestBusinessAreaId}
                    </div>
                  )}
                </div>
                <DropDownMultiCheck
                  dataList={candidateInterestBusinessAreas}
                  selecteds={interview.candidateBusinessAreas || []}
                  setSelecteds={onchangeCandidateBusinessAreas}
                  label={t("Business Area...")}
                  hideSelected={true}
                />
              </div>
            </div>
            <div className="col-md-5 mt-1">
              <div className="form-group">
                <JobRoleDetails
                  searchObject={interview.personalInformation}
                  onChange={onChange}
                  techAreas={candidateInterestTechAreas}
                  techRoles={candidateInterestTechRoles}
                  techAreaFieldName="candidateInterestTechAreaId"
                  techRoleFieldName="candidateInterestTechRoleId"
                >
                  <TechAreaInterestInterviewHelper
                    searchObject={interview.personalInformation}
                    onChange={onChange}
                    candidateInterestTechAreas={candidateInterestTechAreas}
                    candidateInterestTechRoles={candidateInterestTechRoles}
                  />
                </JobRoleDetails>
              </div>
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterviewPageHeader;
